import api from "./api";

/* LIST EMPLOYEES (paginated) */
export const getEmployees = async (params = {}) => {
  const response = await api.get("employees/", { params });
  return response.data;
};

/* DROPDOWN EMPLOYEES */
export const getEmployeesDropdown = async () => {
  const response = await api.get("dropdowns/employees/");
  return response.data.data || response.data || [];
};

/* GET SINGLE EMPLOYEE */
export const getEmployeeById = async (id) => {
  const response = await api.get(`employees/${id}/`);
  return response.data;
};

/* DEPARTMENTS DROPDOWN */
export const getDepartments = async () => {
  const response = await api.get("dropdowns/departments/");
  return response.data.data || response.data || [];
};

/* DESIGNATIONS DROPDOWN */
export const getDesignations = async (departmentId = "") => {
  let url = "dropdowns/designations/";
  if (departmentId) url += `?department=${departmentId}`;
  const response = await api.get(url);
  return response.data.data || response.data || [];
};

/* REPORTING MANAGERS */
export const getReportingManagers = async (departmentId = "", excludeId = "") => {
  let url = "dropdowns/reporting-managers/";
  const params = new URLSearchParams();
  if (departmentId) params.append("department", departmentId);
  if (excludeId)    params.append("exclude_id", excludeId);
  if (params.toString()) url += `?${params.toString()}`;
  const response = await api.get(url);
  return response.data.data || response.data || [];
};

/* CREATE EMPLOYEE */
export const createEmployee = async (formData) => {
  const response = await api.post("employees/", formData);
  return response.data;
};

/* UPDATE EMPLOYEE */
export const updateEmployee = async (id, formData) => {
  const response = await api.put(`employees/${id}/`, formData);
  return response.data;
};

/* DELETE EMPLOYEE */
export const deleteEmployee = async (id, password) => {
  await api.delete(`employees/${id}/`, { data: { password }, params: { password } });
};

/* UPLOAD DOCUMENT */
export const uploadEmployeeDocument = async (id, formData) => {
  const response = await api.post(`employees/${id}/documents/`, formData);
  return response.data;
};

/* DELETE DOCUMENT */
export const deleteEmployeeDocument = async (employeeId, docId, password) => {
  const headers = password ? { "X-Confirm-Password": password } : {};
  await api.delete(`employees/${employeeId}/documents/${docId}/`, { headers, data: { password }, params: { password } });
};

/* RECORD EMPLOYEE EXIT (Resignation / Termination) */
export const recordEmployeeExit = async (id, data) => {
  const response = await api.post(`employees/${id}/record-exit/`, data);
  return response.data;
};
